import * as React from 'react';

export function asyncComponent(importComponent: any) {
    class AsyncComponent extends React.Component<{}, any> {
        constructor(props: {}) {
            super(props);

            this.state = {
                component: null
            };
        }

        async componentDidMount() {
            const { default: component } = await importComponent();

            this.setState({
                component: component
            });
        }

        render() {
            const C = this.state.component;
            return C ? <C {...this.props} /> : null;
        }
    }

    return AsyncComponent;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/AsyncComponent.tsx